import Icons from 'assets/icons'
import Button from 'components/formElements/Button'
import useToast from 'hooks/useToast'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import { PropTypes } from 'prop-types'

const InvoiceApprovalModalContent = ({ handleClose, handleApproved, approvalModal, handleChange, removeFile, filesData, formData }) => {
	const {showToast} = useToast()
	return (
		<div className='w-100 d-flex flex-column gap-3 approval-modal-content'>
			<div className='row text-center'>
				<div className='col-12'>{approvalModal?.text}</div>
			</div>
			{
				approvalModal.invoiceStatusId == 7 && <>
				<div className="row justify-content-center">
					<div className="col-md-11">
					<div className='form-control'>
						<input className='default-input' placeholder='Fatura Numarası' name='invoiceNo' type='text' onChange={(e) => handleChange(e.target.value, 'invoiceNo')} />
					</div>
					</div>
				</div>
				
				</>
			}
			
			{(approvalModal.invoiceStatusId == 2 || approvalModal.invoiceStatusId == 7 )&& (
				<div className='row justify-content-center'>
					<div className='col-md-12 col-xl-11'>
						{filesData?.length > 0 ? (
							filesData?.map((file, i) => (
								<div className='text-sm comment-fileList w-unset' key={i}>
									<div className='d-flex align-items-center'>{file?.fileName}</div>
									<Icons.delete
										onClick={() => {
											removeFile(file)
										}}
										size={16}
									/>
								</div>
							))
						) : (
							<label className='project-file-upload--form--row--item--file-uploader--label' htmlFor='file-uploader'>
								<span className='project-file-upload--form--row--item--file-uploader--label--text'>
									<Icons.plus /> Dosya Ekle
								</span>
							</label>
						)}
						<input
							type='file'
							// accept="image/*,video/*"
							onChange={(e) => handleChange(e.target.files, 'files')}
							id='file-uploader'
							className='project-file-upload--form--row--item--file-uploader--input'
						/>
					</div>
				</div>
			)}
			{
				(approvalModal.invoiceStatusId == 2 || approvalModal.invoiceStatusId == 7) && (
					<div className="row justify-content-center">
				<div className="col-md-12 col-xl-11">
					<div className='form-control'>
						<label htmlFor="" className="form-control-label">
							Açıklama
						</label>
						<input className='default-input' value={formData?.description} placeholder='Açıklama' name='description' type='text' onChange={(e) => handleChange(e.target.value, 'description')} />
					</div>
				</div>
				</div>
				)
			}
			{
				approvalModal?.invoiceStatusId == 2 && <div className="row justify-content-center">
					<div className="col-md-12 col-xl-11">
						<div className="form-control">
							<label htmlFor="" className="form-control-label">
							Kesilecek Ay
							</label>
							<Calendar
								className='w-100'
								view="month" 
								dateFormat="mm/yy"
								placeholder='Kesilecek Ay/Yıl'
								value={formData?.estimatedDate && moment(formData?.estimatedDate).locale('en')._d}
								name='estimatedDate'
								onChange={(e) => {
									handleChange(moment(e.target.value).add(3, 'hours').toISOString(),'estimatedDate')
								}}
							/>
						</div>
					</div>
				</div>
			}
			<div className='row justify-content-center gap-3'>
				<Button handleClick={handleApproved} className='btn-success' title={approvalModal.invoiceStatusId == 2 ? 'Kaydet' : 'Onayla'} />
				<Button
					handleClick={() => {
						if (approvalModal?.invoiceStatusId == 2 && !formData.estimatedDate) {
							showToast('Kesilecek Ay/Yıl seçimini yapınız','error')
						} else {
							handleClose()
						}
					}}
					className='btn-danger-outline'
					title={approvalModal.invoiceStatusId == 2 ? 'Dosya Eklemek İstemiyorum' : 'Vazgeç'}
				/>
			</div>
		</div>
	)
}
InvoiceApprovalModalContent.propTypes = {
	handleClose: PropTypes.func,
	handleApproved: PropTypes.func,
	approvalModal: PropTypes.obj,
	formData: PropTypes.obj,
	filesData: PropTypes.array,
	removeFile: PropTypes.func,
	handleChange: PropTypes.func,
}
export default InvoiceApprovalModalContent
